/**
 * Created by delevauxal on 23/06/2021.
 */
export enum UserIdentityCheckStatus {
  UNKNOWN = 'UNKNOWN',
  PENDING = 'PENDING',
  VALIDATED = 'VALIDATED'
}
